exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n:root {\n    --gutter: 20px;\n}\n.tablet-section-container {\n    padding: var(--gutter);\n    display: grid;\n    grid-gap: calc(var(--gutter) / 2);\n    grid-template-columns: repeat(3, minmax(240px, 1fr));\n    grid-template-rows: repeat(2, minmax(280px, 1fr));\n    align-content: start;\n}\n.tablet-section-container {\n    overflow-y: scroll;\n}\n\n", ""]);

// exports
